
import {Options, Vue} from "vue-class-component";
import AccountService from "@/services/AccountService";
import Loading from 'vue-loading-overlay';
@Options({
  components: {
    Loading
  },
  emits: ['update:show'],
  data: function() {
    return {
      login: {
        email: '',
        password: ''
      },
      failLogin: null,
      loading: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.login.email = null;
      this.login.password = null;
      this.clearFailMessage();
      this.$emit('update:show', false)
    },
    clearFailMessage() {
      this.failLogin = false;
    },
    authenticate () {
      if(this.login.password != null && this.login.password.length > 0) {
        this.loading = true;
        AccountService.funeralSupplierLogin(this.login.email, this.login.password).then((res) => {
          if(res && res.data) {
            this.clearFailMessage();
          } else {
            this.failLogin = true;
          }
          this.loading = false;
        }, () => {
          this.failLogin = true;
          this.loading = false;
        })
      }
    }
  },
})
export default class SupplierLogin extends Vue {

}
